/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener("DOMContentLoaded", function () {
  AOS.init();
});

// Show/hide sale text on PDP
document.addEventListener('variant:changed', function (event) {
  const saleText = document.querySelector('.sale-text');
  if(saleText) {
    const variantId = event.detail.variant.id;
    const saleTextChildren = saleText.children;
    for (let i = 0; i < saleTextChildren.length; i++) {
      const element = saleTextChildren[i];
      if(element.id === `sale-text-${variantId}`) {
        element.removeAttribute('hidden');
      } else {
        element.setAttribute('hidden', '');
      }
    }
  }
});

// Define the new element
class ShopTheLookAccordion extends HTMLElement {
  constructor() {
    super();

    let activeAccordion = this.querySelector(
      ".shop-the-look__accordion-item.active"
    );

    if (activeAccordion) {
      let content = activeAccordion.querySelector(
        ".shop-the-look__accordion-content"
      );
      content.style.height = content.scrollHeight + "px";
    }

    let accordions = document.querySelectorAll(
      ".shop-the-look__accordion-label"
    );

    [...accordions].forEach((accordion) => {
      accordion.addEventListener("click", () => {
        let parent = accordion.parentElement;
        let content = parent.querySelector(".shop-the-look__accordion-content");
        if (parent.classList.contains("active")) {
          content.style.height = 0;
          parent.classList.remove("active");
        } else {
          [...accordions].forEach((accordion) => {
            let parent = accordion.parentElement;
            let content = parent.querySelector(
              ".shop-the-look__accordion-content"
            );
            content.style.height = 0;
            parent.classList.remove("active");
          });
          content.style.height = content.scrollHeight + "px";
          parent.classList.add("active");
        }
      });
    });
  }
}

// Define the new element
customElements.define("shop-the-look-accordion", ShopTheLookAccordion);

// ============================================================================================================
// KLAVIYO BACK IN STOCK FUNCTIONALITY
// ============================================================================================================

(function () {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlaviyoBIS);
  } else {
    initKlaviyoBIS();
  }

  function initKlaviyoBIS() {
    const bisWrappers = document.querySelectorAll('[data-product-bis-wrapper]');

    bisWrappers.forEach((wrapper) => {
      const emailInput = wrapper.querySelector('.klaviyo-bis-email');
      const submitButton = wrapper.querySelector('.klaviyo-bis-submit');
      const messageDiv = wrapper.querySelector('.klaviyo-bis-message');

      if (!emailInput || !submitButton || !messageDiv) return;

      // Listen for variant changes
      const productForm = submitButton.closest('.product-form__payment-container')?.closest('form');
      if (productForm) {
        const variantIdInput = productForm.querySelector('input[name="id"]');
        if (variantIdInput) {
          // Set initial state
          updateBISVisibility(wrapper, productForm);
          
          // Create a MutationObserver to watch for changes to the variant input
          const observer = new MutationObserver(() => {
            updateBISVisibility(wrapper, productForm);
          });

          observer.observe(variantIdInput, {
            attributes: true,
            attributeFilter: ['value'],
          });

          // Also listen for change events
          variantIdInput.addEventListener('change', () => {
            updateBISVisibility(wrapper, productForm);
          });

          // Watch for changes to the disabled attribute on variant input
          productForm.addEventListener('change', () => {
            updateBISVisibility(wrapper, productForm);
          });
        }
      }

      submitButton.addEventListener('click', async function () {
        const email = emailInput.value.trim();

        // Validate email
        if (!email || !isValidEmail(email)) {
          showMessage(messageDiv, 'Please enter a valid email address.', 'error');
          return;
        }

        // Get product variant ID
        const productForm = document.querySelector('[data-product-add-to-cart-button]')?.closest('form');
        const variantIdInput = productForm?.querySelector('input[name="id"]');
        const variantId = variantIdInput?.value;

        if (!variantId) {
          showMessage(messageDiv, 'Unable to get product information.', 'error');
          return;
        }

        // Show loading state
        submitButton.setAttribute('loading', '');
        submitButton.disabled = true;

        try {
          // Subscribe to back in stock
          await subscribeToBackInStock(email, variantId, wrapper);
          showMessage(messageDiv, "Thank you! We'll notify you when this item is back in stock.", 'success');
          emailInput.value = '';
        } catch (error) {
          showMessage(messageDiv, error.message || 'Something went wrong. Please try again.', 'error');
        } finally {
          submitButton.removeAttribute('loading');
          submitButton.disabled = false;
        }
      });

      // Allow submitting with Enter key
      emailInput.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          submitButton.click();
        }
      });
    });
  }

  function updateBISVisibility(wrapper, productForm) {
    const addToCartButton = productForm.querySelector('[data-product-add-to-cart-button]');
    const emailInput = wrapper.querySelector('.klaviyo-bis-email');

    if (addToCartButton) {
      const isHidden =
        addToCartButton.hasAttribute('hidden') ||
        addToCartButton.hasAttribute('disabled') ||
        addToCartButton.classList.contains('hidden');

      // Check button text to see if it says "Sold Out"
      const buttonText = addToCartButton.textContent.trim().toLowerCase();
      const isSoldOut = buttonText.includes('sold out') || buttonText.includes('unavailable');

      if (isHidden || isSoldOut) {
        wrapper.style.display = 'block';
        // Make email required when form is visible
        if (emailInput) {
          emailInput.setAttribute('required', '');
        }
      } else {
        wrapper.style.display = 'none';
        // Remove required when form is hidden
        if (emailInput) {
          emailInput.removeAttribute('required');
        }
      }
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showMessage(messageDiv, text, type) {
    messageDiv.textContent = text;
    messageDiv.className = 'klaviyo-bis-message ' + type;
    messageDiv.style.display = 'block';

    // Hide message after 5 seconds
    setTimeout(() => {
      messageDiv.style.display = 'none';
    }, 5000);
  }

  async function subscribeToBackInStock(email, variantId, wrapper) {
    // Use Klaviyo's back in stock API
    if (typeof klaviyo === 'undefined') {
      throw new Error('Klaviyo is not loaded');
    }

    // Get the Klaviyo account ID from data attribute
    const klaviyoAccountId = wrapper.dataset.klaviyoAccountId;
    
    if (!klaviyoAccountId || klaviyoAccountId.length === 0) {
      throw new Error('Klaviyo account ID not configured');
    }

    return new Promise((resolve, reject) => {
      try {
        // Track the back in stock request
        klaviyo.push([
          'track',
          'Back in Stock',
          {
            variant: variantId,
            product: window.location.href,
            email: email,
          },
        ]);

        // Identify the user
        klaviyo.push([
          'identify',
          {
            $email: email,
          },
        ]);

        // Subscribe using the direct API endpoint
        fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            a: klaviyoAccountId,
            email: email,
            variant: variantId,
            platform: 'shopify',
          }),
        })
          .then((response) => {
            if (response.ok) {
              resolve();
            } else {
              return response.text().then((text) => {
                reject(new Error('Failed to subscribe: ' + text));
              });
            }
          })
          .catch((error) => {
            // Even if the fetch fails, the klaviyo.push might have worked
            console.warn('Klaviyo BIS fetch error:', error);
            resolve();
          });
      } catch (error) {
        reject(error);
      }
    });
  }
})();
